module.exports = __webpack_public_path__ + "static/media/qr-code-128.7daab20b.png";